import api from '@motionelements/core/src/api/base-api-v2';
import { STUDIO_AI_API_VERSION } from '@/constants';

// eslint-disable-next-line
export const getCoinsBalance = async () => api.get(`/${STUDIO_AI_API_VERSION}/coins/balance`);
